<template>
  <div class="icf-root">
    <el-form :model="courseItem" ref="form" :rules="rules" label-position="top" size="small">

      <!-- 课程 -->
      <el-form-item prop="Course" label="课程">
        <course-input v-model="courseItem.Course" />
        <!-- 课程选中预览 -->
        <div v-if="courseItem.Course && courseItem.Course.CourseCode" class="course-preview">
          <span class="course-preview-code">{{ courseItem.Course.CourseCode }}</span>
          <span class="course-preview-name">{{ courseItem.Course.CourseName }}</span>
        </div>
      </el-form-item>

      <!-- 学年 + 学期 -->
      <div class="icf-row">
        <el-form-item prop="SchoolYear" label="学年" style="flex:1;min-width:0">
          <el-date-picker
            v-model="courseItem.SchoolYear"
            type="year"
            placeholder="选择学年"
            style="width:100%"
          />
        </el-form-item>

        <el-form-item prop="Term" label="学期" style="flex:1;min-width:0">
          <el-select v-model="courseItem.Term" placeholder="请选择学期" style="width:100%">
            <el-option-group label="Semester（半年）">
              <el-option value="S1">
                <div class="term-option">
                  <span class="term-code s-type">S1</span>
                  <span class="term-desc">2月 — 6月</span>
                </div>
              </el-option>
              <el-option value="S2">
                <div class="term-option">
                  <span class="term-code s-type">S2</span>
                  <span class="term-desc">7月 — 11月</span>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group label="Term（三学期）">
              <el-option value="T1">
                <div class="term-option">
                  <span class="term-code t-type">T1</span>
                  <span class="term-desc">2月下旬 — 5月中</span>
                </div>
              </el-option>
              <el-option value="T2">
                <div class="term-option">
                  <span class="term-code t-type">T2</span>
                  <span class="term-desc">6月上旬 — 8月下旬</span>
                </div>
              </el-option>
              <el-option value="T3">
                <div class="term-option">
                  <span class="term-code t-type">T3</span>
                  <span class="term-desc">9月中 — 12月中</span>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </div>

      <!-- 操作按钮 -->
      <div class="icf-footer">
        <el-button class="btn" @click="$emit('cancel')">取消</el-button>
        <el-button class="btn btn--green" @click="createcourse">
          <i class="el-icon-check" /> 确认添加
        </el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
import CourseInput from '@/components/CourseInput/index'

export default {
  name: 'InputCourseForm',
  components: { CourseInput },
  props: {
    SchoolName: { type: String, default: '' }
  },
  data() {
    const validateSubject = (rule, value, callback) => {
      if (!value || !value.CourseCode) return callback(new Error('请输入课程代码'))
      if (!value.CourseName)          return callback(new Error('请输入课程名称'))
      return callback()
    }
    return {
      rules: {
        Course:     [{ required: true, message: '请选择课程', trigger: 'blur' }, { validator: validateSubject }],
        SchoolYear: [{ required: true, message: '请选择学年', trigger: 'change' }],
        Term:       [{ required: true, message: '请选择学期', trigger: 'change' }]
      },
      courseItem: {
        Course:     { CourseCode: '', CourseName: '' },
        SchoolYear: new Date(),
        Term:       null
      }
    }
  },
  methods: {
    createcourse() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.courseItem.Course.ID = -Number(new Date())
        this.$emit('createcourse', this.courseItem)
      })
    }
  }
}
</script>

<style scoped>
.icf-root { padding: 4px 0 0; }

/* form 标签 */
.icf-root >>> .el-form-item__label {
  font-size: 13px;
  font-weight: 500;
  color: #555;
  padding-bottom: 5px;
  line-height: 1.4;
}
.icf-root >>> .el-form-item {
  margin-bottom: 18px;
}

/* 课程选中预览 —— 紧贴在输入框下方，属于 form-item 内部 */
.course-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 7px 11px;
  background: #f0f6ff;
  border: 0.5px solid #B5D4F4;
  border-radius: 6px;
}
.course-preview-code {
  font-size: 12px;
  font-weight: 500;
  color: #0C447C;
  background: #E6F1FB;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}
.course-preview-name {
  font-size: 13px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 学年+学期并排 */
.icf-row {
  display: flex;
  gap: 14px;
}

/* 学期下拉选项 */
.term-option {
  display: flex;
  align-items: center;
  gap: 10px;
}
.term-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px; height: 20px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}
.s-type { background: #EAF3DE; color: #27500A; }
.t-type { background: #EEEDFE; color: #3C3489; }
.term-desc { font-size: 12px; color: #aaa; }

/* 底部操作 */
.icf-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 14px;
  border-top: 0.5px solid rgba(0,0,0,0.07);
}

/* 通用按钮 */
.btn {
  height: 30px !important; padding: 0 14px !important;
  border-radius: 6px !important; font-size: 13px !important;
  border: 0.5px solid rgba(0,0,0,0.1) !important;
  background: #fff !important; color: #555 !important;
  display: inline-flex !important; align-items: center !important; gap: 4px !important;
}
.btn:hover        { background: #f5f5f5 !important; }
.btn--green       { background: #EAF3DE !important; border-color: #C0DD97 !important; color: #27500A !important; }
.btn--green:hover { background: #d4ecbe !important; }
</style>